import styled from 'styled-components';
import slide2 from 'assets/images/desktop/slide2.jpg';
export { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Image = styled.img.attrs({ src: slide2 })`
  height: 100%;
`;
